module.exports = __webpack_public_path__ + "files/64691ddeb9e8710d5d161b20fdb8e129.png";